import ScrollToTop from '@utils/scrollToTop';
import { useLocation } from 'react-router-dom';
import { useDocTitle } from '@hooks/useDocTitle';
import { OutsideContainer, OutsideLayoutContent, OutsideContent } from './style';

const Outside = ({ children }) => {
    const location = useLocation();
    useDocTitle({ location });

    return (
        <>
            <ScrollToTop />
            <OutsideContainer>
                <OutsideLayoutContent>
                    <OutsideContent>{children}</OutsideContent>
                </OutsideLayoutContent>
            </OutsideContainer>
        </>
    );
};

export default Outside;
